__turbopack_context__.v({
  "headerImage": "Header-module__Xf1azq__headerImage",
  "logo": "Header-module__Xf1azq__logo",
  "logoContainer": "Header-module__Xf1azq__logoContainer",
  "mainTitle": "Header-module__Xf1azq__mainTitle",
  "pageHeader": "Header-module__Xf1azq__pageHeader",
  "pageHeaderContent": "Header-module__Xf1azq__pageHeaderContent",
  "pageHeaderText": "Header-module__Xf1azq__pageHeaderText",
  "subTitle": "Header-module__Xf1azq__subTitle",
});
